<template>
	<div class="cofirm" v-show="showConfrim" @click.stop="close()">
		<div class="cofirm-box" @click.stop="">
			<div class="title">

				<img class="sign decorate" src="../../assets/img/home/decorate-left.png" />
				&nbsp;&nbsp;提示&nbsp;&nbsp;
				<img class="sign decorate" src="../../assets/img/home/decorate-right.png" />
			</div>
			<div class="body" v-html="text">
			</div>
			<div class="foot">
				<div class="cancel" @click="cancel()">{{cancelText}}</div>&nbsp;
				<div class="submit" @click="submit()">{{submitText}}</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Confirm",
		data() {
			return {
				text: '确定',
				submitText:'确 定',
				cancelText:'取 消',
				showConfrim: false
			};
		},
		created() {},
		computed: {},
		methods: {
			show(text, submitCallBack,submitText, cancelCallBack,cancelText) {
				this.showConfrim = true
				this.text = text
				document.body.appendChild(this.$el)
				this.submitCallBack = submitCallBack?submitCallBack:()=>{}
				this.submitText = submitText?submitText:'确 定'
				this.cancelCallBack = cancelCallBack?cancelCallBack:()=>{}
				this.cancelText = cancelText?cancelText:'取 消'
			},
			close() {
				this.showConfrim = false
				document.body.removeChild(this.$el)
			},
			submitCallBack() {},
			cancelCallBack() {},
			cancel(){
				this.close()
				this.cancelCallBack()
			},
			submit() {
				this.close()
				this.submitCallBack()
			}

		},
	};
</script>
<style scoped>
	input {
		background: none;
		outline: none;
		border: none;
		width: 100%;
	}

	.cofirm {
		height: 100vh;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	.cofirm-box {

		border-radius: 6px;
		width: 80%;
		margin: 0 auto;
		overflow: hidden;
	}

	.title {
		background-color: #ffffff;
		color: #686e3f;
		padding: 12px;
		font-size: 16px;
	}

	.decorate {
		width: 20%;
	}

	.logo {
		width: 140px;
	}

	.close-btn {
		width: 20px;
		float: right;
	}

	.body {
		background-color: #efe8c2;
		padding: 30px;
		color: #686e3f;
	}


	.foot {
		background-color: #ffffff;
		color: #686e3f;
		padding: 16px;
	}

	.submit {
		background-color: #90ba89;
		width: 40%;
		display: inline-block;
		color: white;
		border-radius: 50px;
		margin: 0 auto;
		padding: 6px;
	}

	.cancel {
		background-color: #efe8c2;
		width: 40%;
		display: inline-block;
		color: white;
		border-radius: 50px;
		margin: 0 auto;
		padding: 6px;
	}

	.cell {
		display: flex;
		padding: 4px 8px;
	}

	.cell .input-box {
		flex: 1;
		background-color: #ffffff;
		border-radius: 60px;
		text-align: left;
		display: flex;
		justify-content: flex-start;
		padding: 4px 12px;
	}

	.cell .input-box img {
		width: 16px;
		vertical-align: middle;
	}

	.cell .label {
		line-height: 18px;
		height: 18px;
		padding: 4px 12px;
		color: #686e3f;
	}

	.cell .input-box .input {
		vertical-align: middle;
		border: none;
		flex: 1;
		padding: 2px 6px;
		display: block;
	}

	.code {
		width: auto;
		display: inline-block;
		background-color: #dcce6b;
		border-radius: 60px;
		color: #ffffff;
		line-height: 28px;
		vertical-align: middle;
		text-align: center;
		margin-left: 10px;
		padding: 0 10px;
		font-size: 12px;
	}
</style>
